import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants, getQuery } from 'helpers'


// busNumber [], routeNumber, []
const fetch = ({ filters: query = {}, fetchCount }) => {
  reducers.lscTransportControl.table.setFetching(true)

  const query1 = getQuery({
    busNumber: query.bus,
    routeNumber: query.route,
    startDate: query.dateFrom,
    endDate: query.dateTo,
    offset: query.offset || 0,
  })

  const query2 = getQuery({
    busNumber: query.bus,
    routeNumber: query.route,
    startDate: query.dateFrom,
    endDate: query.dateTo,
    offset: query.offset || 0,
    limit: query.limit,
  })

  return Promise.all([
    request.get(constants.lscTransportControl.transportationCount + query1),
    // fetchCount ? request.get(constants.lscTransportControl.transportationCount + query1) : Promise.resolve({ data: {}}),
    request.get(constants.lscTransportControl.transportation + query2)
  ])
    .then(([ { data: { count } }, { data: body }]) => {
      const data = body.map(({
        busNumber, // "602",
        routeNumber, // "1",
        runsCount, // 20,
        runsLength, // 349.96
      }) => ({
        bus: busNumber, //: "681",
        date: Date.now(), //: "2018-12-04T00:00:00.000Z",
        error: 0, //: 5.6,
        length: runsLength, //: 17742,
        // duration, //: 55,
        runsCount, //: 55,
        route: routeNumber, //: "3"
      }))

      if (data.length > query.limit) {
        reducers.lscTransportControl.table.setData(
          [...data].splice(query.offset || 0, query.limit || 10)
        )
      }
      else {
        reducers.lscTransportControl.table.setData(data)
      }

      if (count) {
        reducers.lscTransportControl.table.setPages(Math.ceil(count / (query.limit || 10)))
      }

      // if (!query.offset) {
      //   reducers.lscTransportControl.table.setActivePageId(1)
      // }

      reducers.lscTransportControl.table.setFetching(false)
    })
    .catch((err) => {
      console.log(err)
      reducers.lscTransportControl.table.setFetching(false)
    })
}


const setActivePageId = (activePageId) =>
  reducers.lscTransportControl.table.setActivePageId(activePageId)

const setPages = (pages) =>
  reducers.lscTransportControl.table.setPages(pages)


export default {
  fetch,
  setPages,
  setActivePageId,
}
